import { SET_ORDERS_MAX_DAYS_AGO } from "../constants/Queries";

export function setOrdersMaxDaysAgo(days) {
  return {
    type: SET_ORDERS_MAX_DAYS_AGO,
    days,
  };
}
